import { render, staticRenderFns } from "./IconSvgTwitter.vue?vue&type=template&id=426fd01d&scoped=true&"
import script from "./IconSvgTwitter.vue?vue&type=script&lang=js&"
export * from "./IconSvgTwitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426fd01d",
  null
  
)

export default component.exports